<template>
  <v-app :class="['templateBuy', index === 0 ? 'loading' : '']">
    <v-dialog v-model="dialog" width="658" :fullscreen="fullscreen">
      <div class="tb_dialog" v-if="index === 0">
        <div class="d-flex justify-center align-center py-16">
          <v-icon class="tb_loading" x-large v-if="index === 0">
            {{ mdiLoading }}
          </v-icon>
        </div>
      </div>
      <div class="tb_dialog tb_dialog1" v-if="index === 1">
        <div class="tb_header">
          <div>购买引导</div>
          <div>第一步：确认模板</div>
          <div>
            <v-btn icon>
              <v-icon color="white" @click.stop="reload">
                {{ mdiClose }}
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="tb_body">
          <div class="template_buy_flex">
            <div class="tb_pic">
              <img :src="data.pc_img" alt="" />
            </div>
            <div class="tb_info">
              <h2>{{ data.title }}</h2>
              <div class="tb_money">
                <div class="c_ff4146">¥ {{ data.money }} 元</div>
              </div>
              <ul>
                <li>产品编号： {{ data.number }}</li>
                <li>主题版本： v{{ data.version }}</li>
              </ul>
            </div>
          </div>
          <p class="template_buy_text">
            模板所有信息均可在后台或模板文件中进行修改，如具备专业 web
            前端技术，还可以对整体布局进行修改。
          </p>
        </div>
        <div class="tb_footer">
          <div class="c_ff4146 f18">¥ {{ data.money }}</div>
          <div class="color f14">开放源代码，云优官方可提供首次安装服务</div>
          <div class="next_btn">
            <button class="tb_btn1" @click="index = 2">下一步</button>
          </div>
        </div>
      </div>
      <div class="tb_dialog tb_dialog2" v-if="index === 2">
        <div class="tb_header">
          <div>购买引导</div>
          <div>第二步：选择授权版本</div>
          <div>
            <v-btn icon>
              <v-icon color="white" @click.stop="dialog = false">
                {{ mdiClose }}
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="tb_body">
          <div class="authorize_buy_flex">
            <ul>
              <li
                :class="{ active: param.authorize_id === null }"
                @click="param.authorize_id = null"
              >
                <dl>
                  <dt>免费版</dt>
                  <dd>
                    价格
                    <span class="color">0</span>
                    元
                  </dd>
                </dl>
                <dl>
                  <dd>不允许去版权</dd>
                  <dd>限个人使用</dd>
                  <dd>无技术支持</dd>
                </dl>
                <div class="media_640 wp_check">
                  <v-icon>
                    {{ mdiCheckBold }}
                  </v-icon>
                </div>
              </li>
              <li
                :class="{ active: param.authorize_id === '0' }"
                @click="param.authorize_id = '0'"
              >
                <dl>
                  <dt>标准版</dt>
                  <dd>
                    价格
                    <span class="color">
                      {{ data.config_authorize[0].money }}
                    </span>
                    元
                  </dd>
                  <dd class="small">
                    {{
                      data.active === 1 ? '双11组合购买' : '同模板一起购买享'
                    }}
                    <span class="c_ff7e00">
                      优惠{{ data.config_authorize[0].discount }}元
                    </span>
                  </dd>
                </dl>
                <dl>
                  <dd>允许去版权</dd>
                  <dd>允许商用</dd>
                  <dd>无技术支持</dd>
                  <dd>永久使用</dd>
                </dl>
                <div class="media_640 wp_check">
                  <v-icon>
                    {{ mdiCheckBold }}
                  </v-icon>
                </div>
              </li>
              <li
                :class="{ active: param.authorize_id === '1' }"
                @click="param.authorize_id = '1'"
              >
                <dl>
                  <dt>高级版</dt>
                  <dd>
                    价格
                    <span class="color">
                      {{ data.config_authorize[1].money }}
                    </span>
                    元
                  </dd>
                  <dd class="small">
                    同模板一起购买
                    <span class="c_ff7e00">
                      优惠{{ data.config_authorize[1].discount }}元
                    </span>
                  </dd>
                </dl>
                <dl>
                  <dd>允许去版权</dd>
                  <dd>允许商用</dd>
                  <dd>vip客服</dd>
                  <dd>永久使用</dd>
                </dl>
                <div class="media_640 wp_check">
                  <v-icon>
                    {{ mdiCheckBold }}
                  </v-icon>
                </div>
              </li>
            </ul>
          </div>
          <div class="authorize_buy_btn">
            <a
              class="tb_btn2 small"
              href="/code/fenzhan/price/"
              target="_blank"
            >
              详细查看授权各版本的对比
            </a>
            <a
              class="tb_btn2 small"
              href="https://docs.qq.com/doc/DQXluRm1mc2FIb2FJ"
              target="_blank"
            >
              如何选购
            </a>
            <a
              class="tb_btn2 small"
              href="https://docs.qq.com/doc/DUmxibGhKYmZJUWpZ"
              target="_blank"
              v-if="data.lid === '0'"
            >
              领取优惠券
            </a>
          </div>
        </div>
        <div class="tb_footer">
          <div>
            <button class="tb_btn3" @click="index = 1">上一步</button>
          </div>
          <div class="tbfc">
            <span class="c_ff4146 f18">¥ {{ dialog2Money }}</span>
            <span class="c_ff7e00 f14">已优惠{{ getAuthorizeDiscount }}</span>
          </div>
          <div>
            <!-- <button class="tb_btn1" @click="index = 3">下一步</button> -->

            <button class="tb_btn1" @click="submitSkip">
              结算
            </button>
          </div>
        </div>
      </div>
      <div class="tb_dialog tb_dialog3" v-if="index === 3">
        <div class="tb_header">
          <div>购买引导</div>
          <div>第三步：选择主机</div>
          <div>
            <v-btn icon>
              <v-icon color="white" @click.stop="dialog = false">
                {{ mdiClose }}
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="tb_body">
          <div class="mb-4">
            <p class="c_ff4146">
              所有主机均不可以发布非法及管控消息，违者一律永久关停处理且不退款；
            </p>
            <p>
              <span class="c_40a77a">国内主机需要备案才能绑定正式域名，</span>
              如果购买国内主机官方将赠送一个备案码，如果您不需要备案，请选择香港主机
            </p>
          </div>
          <ul>
            <li class="d-flex align-center mb-3">
              <span class="label">类型</span>
              <v-select
                name="space_id"
                :items="selectSpace"
                dense
                solo
                v-model="param.space_id"
                style="width: 158px;"
                placeholder="请选择"
              />
              <div class="partition"></div>
              <span class="label">购买时长</span>
              <v-select
                name="space_year"
                :items="selectYear"
                dense
                solo
                v-model="param.space_year"
                style="width: 76px;"
              />
            </li>
            <li v-if="false">
              <span class="label">活动</span>
              <span style="color: #fe6568;">买2年送1年，买3年送2年！</span>
            </li>
            <li>
              <span class="label">费用</span>
              <span class="c_ff4146 tb_money">{{ getSpaceMoney }}</span>
              <span class="label">元</span>
            </li>
            <li>
              <span class="label">其他</span>
              <span>不限流量，购买后自动安装！</span>
            </li>
          </ul>
        </div>
        <div class="tb_footer">
          <div>
            <button class="tb_btn3" @click="index = 2">上一步</button>
          </div>
          <div class="tbfc">
            <span class="c_ff4146 f18">¥ {{ dialog3Money }}</span>
            <span class="c_ff7e00 f14">已优惠{{ getAuthorizeDiscount }}</span>
            <div class="media_640">
              <button class="tb_btn2" @click="submitSkip">
                我有主机，直接跳过
              </button>
            </div>
          </div>
          <div>
            <button class="tb_btn2" @click="submitSkip">
              我有主机，直接跳过
            </button>
            <button class="tb_btn4" @click="submit">立即下单</button>
          </div>
        </div>
      </div>
      <div class="tb_dialog tb_dialog4" v-if="index === 4">
        <div
          class="d-flex justify-space-between align-center"
          v-if="progress_state === '-1'"
        >
          <div></div>
          <div>
            <v-btn icon>
              <v-icon color="white" @click.stop="dialog = false">
                {{ mdiClose }}
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="d-flex flex-column justify-center align-center px-5 py-9">
          <div class="mb-3" v-if="progress_state === '-1'">
            <button class="tb_btn4 small ml-4">
              {{ progress_data[progress_state]['name'] }}
            </button>
          </div>
          <div class="mb-3" v-else>
            站点安装中，正在
            <button class="tb_btn1 small ml-4">
              {{ progress_data[progress_state]['name'] }}
            </button>
          </div>
          <div class="d-flex align-center">
            <v-progress-linear
              :value="progress_data[progress_state]['progress']"
              height="11"
              color="primary"
              background-color="white"
              style="width: 556px;"
              rounded
            ></v-progress-linear>
            <strong class="ml-3">
              {{ Math.ceil(progress_data[progress_state]['progress']) }}%
            </strong>
          </div>
        </div>
      </div>
      <div class="tb_dialog tb_dialog5" v-if="index === 5">
        <div class="tb_header">
          <div></div>
          <div>安装成功</div>
          <div>
            <v-btn icon>
              <v-icon color="white" @click.stop="reload">
                {{ mdiClose }}
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="tb_body">
          <div class="mb-4">
            <dl>
              <dt>您的站点 {{ spaceDate.topdomain }} 已开通</dt>
              <dd>临时域名：{{ spaceDate.topdomain }}</dd>
              <dd>临时后台：{{ spaceDate.topdomain }}/yunu.php</dd>
              <dd>账号：admin</dd>
              <dd>密码：admin</dd>
            </dl>
          </div>
        </div>
        <div class="tb_footer">
          <div></div>
          <div>
            <a class="tb_btn2" href="javascript:;" @click="doCopy">
              复制信息
            </a>
            <a
              class="tb_btn2"
              :href="`${domain}/User/Server/info/id/${spaceDate.id}`"
              target="_blank"
              v-if="param.template_id"
            >
              管理空间
            </a>
            <a class="tb_btn4" :href="data.course" target="_blank">
              查看详细使用教程
            </a>
          </div>
        </div>
      </div>
    </v-dialog>
    <Message ref="message" />
    <Confirm ref="confirm" />
  </v-app>
</template>

<script>
import Message from '@/components/Message.vue'
import Confirm from '@/components/Confirm.vue'
import { mdiClose, mdiLoading, mdiCheckBold } from '@mdi/js'

import { mapState } from 'vuex'

export default {
  name: 'templateBuy',
  components: {
    Message,
    Confirm,
  },
  data: () => ({
    mdiClose,
    mdiLoading,
    mdiCheckBold,
    dialog: false,
    fullscreen: false,
    index: 0,
    data: {},
    selectYear: [
      {
        text: '1年',
        value: '1',
      },
      {
        text: '2年',
        value: '2',
      },
      {
        text: '3年',
        value: '3',
      },
      {
        text: '5年',
        value: '5',
      },
    ],
    param: {
      template_id: null,
      authorize_id: '0',
      space_id: null,
      space_year: '1',
    },
    progress_state: 0,
    progress_data: {
      '-1': {
        progress: 0,
        name: '失败',
      },
      0: {
        progress: 0,
        name: '排队中',
      },
      1: {
        progress: 0,
        name: '开通空间',
      },
      2: {
        progress: 15,
        name: '程序下载',
      },
      3: {
        progress: 50,
        name: '程序解压',
      },
      4: {
        progress: 85,
        name: '程序安装',
      },
      5: {
        progress: 100,
        name: '完成',
      },
    },
    spaceDate: {},
  }),
  computed: {
    ...mapState(['domain']),
    selectSpace() {
      let result = []
      for (const key in this.data.config_space) {
        const value = this.data.config_space[key]
        result.push({
          text: value.name,
          value: key,
        })
      }
      return result
    },
    getAuthorizeMoney() {
      return this.param.authorize_id === null
        ? 0
        : this.data.config_authorize[this.param.authorize_id].money
    },
    getAuthorizeDiscount() {
      return this.param.authorize_id === null
        ? 0
        : this.data.config_authorize[this.param.authorize_id].discount
    },
    dialog2Money() {
      return (
        this.data.money + this.getAuthorizeMoney - this.getAuthorizeDiscount
      )
    },
    getSpaceMoney() {
      return this.param.space_id === null
        ? 0
        : this.data.config_space[this.param.space_id].money *
            this.param.space_year
    },
    dialog3Money() {
      return this.param.space_id === null
        ? this.dialog2Money
        : this.dialog2Money + this.getSpaceMoney
    },
  },
  created() {
    document.querySelector('body').addEventListener('click', (event) => {
      if (event.target.getAttribute('buy-button') === 'templateBuy') {
        let id = event.target.getAttribute('data-id')
        this.init(id)
      }
    })
    if (window.yunu) {
      window.yunu.progressHandle = (oid, course) => {
        this.data.course = course
        this.progressHandle(oid)
        this.dialog = true
      }
    }
  },
  methods: {
    init(id) {
      this.index = 0
      this.fullscreen = document.body.clientWidth < 640
      this.dialog = true
      this.$http({
        method: 'POST',
        url: '/User/Api/template_buy_info',
        data: {
          id,
        },
      }).then(async ({ data: res }) => {
        if (res.state === 1) {
          this.data = res.data
          this.param.template_id = this.data.id
          this.param.space_id = '1'
          this.param.coupon_id = this.data.coupon && this.data.coupon.id
          this.index = 2
          if (window.authorize_id !== undefined) {
            this.param.authorize_id = window.authorize_id
          }
        } else if (res.state === 2) {
          this.dialog = false
          let res = await this.$dialog.confirm({
            title: '提示',
            text: '尊敬的用户，请登录后再进行购买，点击确认立即登录',
          })
          if (res) {
            window.yunu.login()
          }
        } else {
          this.dialog = false
          this.$refs.message.init(
            {
              text: res.info,
              color: 'error',
            },
            () => {
              this.dialog = false
            }
          )
        }
      })
    },
    submit() {
      let authorize_name =
        this.param.authorize_id !== null
          ? this.data.config_authorize[this.param.authorize_id]['name']
          : '免费版'
      let space_name =
        this.param.space_id !== null
          ? this.data.config_space[this.param.space_id]['name']
          : '免费版'
      this.$refs.confirm.init({
        title: '提示',
        text: `您当前购买的模板编号是${
          this.data.number
        }，授权版本是${authorize_name}，选择的主机是${space_name}，总价是${
          this.dialog3Money
        }元，${
          this.data.coupon
            ? `优惠券抵消金额${this.data.coupon.money}元最终价格为${this
                .dialog3Money - this.data.coupon.money}元，`
            : ''
        }您确定购买吗？`,
        confirm: () => {
          this.index = 0
          this.$http({
            method: 'POST',
            url: '/User/Api/template_buy',
            data: this.param,
          }).then(({ data: res }) => {
            this.index = 3
            if (res.state === 1) {
              // this.$refs.message.init({
              //   text: res.info,
              //   color: 'success',
              //   timeout: 1000,
              // })
              this.progressHandle(res.data)
            } else if (res.state === 2) {
              this.$refs.confirm.init({
                title: '提示',
                text: res.info,
                cancelShow: false,
                confirmText: '充值',
                confirm: () => {
                  window.open('http://u.yunucms.com/User/Finance/recharge.html')
                },
              })
            } else {
              this.$refs.message.init({
                text: res.info,
                color: 'error',
              })
            }
          })
        },
      })
    },
    submitSkip() {
      let authorize_name =
        this.param.authorize_id !== null
          ? this.data.config_authorize[this.param.authorize_id]['name']
          : '免费版'
      this.$refs.confirm.init({
        title: '提示',
        text: `您当前购买的模板编号是${
          this.data.number
        }，授权版本是${authorize_name}，总价是${this.dialog2Money}元，${
          this.data.coupon
            ? `优惠券抵消金额${this.data.coupon.money}元最终价格为${this
                .dialog2Money - this.data.coupon.money}元，`
            : ''
        }
          您确定购买吗？`,
        confirm: () => {
          this.index = 0
          this.$http({
            method: 'POST',
            url: '/User/Api/template_buy',
            data: { ...this.param, skip: 1 },
          }).then(({ data: res }) => {
            this.index = 2
            if (res.state === 1) {
              this.$refs.message.init(
                {
                  text: res.info,
                  color: 'success',
                  timeout: 1000,
                },
                () => {
                  window.location.href =
                    this.domain + '/User/Business/website.html'
                }
              )
            } else if (res.state === 2) {
              this.$refs.confirm.init({
                title: '提示',
                text: res.info,
                cancelShow: false,
                confirmText: '充值',
                confirm: () => {
                  window.open('http://u.yunucms.com/User/Finance/recharge.html')
                },
              })
            } else {
              this.$refs.message.init({
                text: res.info,
                color: 'error',
              })
            }
          })
        },
      })
    },
    progressHandle(oid) {
      this.index = 4
      this.progress_state = 0
      const ws = new WebSocket('ws://u.yunucms.com:3000/progress/' + oid)
      // const ws = new WebSocket('ws://localhost:3000/progress/' + oid)
      let pingTimeout

      ws.addEventListener('open', heartbeat)

      ws.addEventListener('message', (event) => {
        clearTimeout(pingTimeout)
        let res = JSON.parse(event.data)
        this.progress_state = res.data || 0
        if (res.data === '5') {
          this.$http({
            method: 'POST',
            url: '/User/Api/spacefind',
            data: {
              id: oid,
            },
          }).then(({ data: res }) => {
            if (res.state === 1) {
              this.spaceDate = res.data
              this.index = 5
            } else {
              this.$refs.message.init({
                text: res.info,
                color: 'error',
              })
            }
          })
        }
        if (res.data === '5' || res.data === '-1') {
          ws.close()
          return
        }
        heartbeat()
      })

      ws.addEventListener('close', () => {
        clearTimeout(pingTimeout)
        if (this.progress_state !== '5') {
          this.progress_state = '-1'
        }
      })

      function heartbeat() {
        clearTimeout(pingTimeout)
        pingTimeout = setTimeout(() => {
          ws.close()
        }, 30000)
      }
    },
    doCopy() {
      const container = document.querySelector('.v-dialog')
      let text = `临时域名：${this.spaceDate.topdomain}\r\n临时后台：${this.spaceDate.topdomain}/yunu.php\r\n账号：admin\r\n密码：admin`
      this.$copyText(text, container).then(
        () => {
          this.$refs.message.init({
            text: '复制成功',
            color: 'success',
          })
        },
        (e) => {
          this.$refs.message.init({
            text: '复制失败',
            color: 'error',
          })
          console.log(e)
        }
      )
    },
    reload() {
      this.dialog = false
      window.location.reload()
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/scss/variables.scss';
.color {
  color: $color;
}
.c_ff4146 {
  color: $c_ff4146;
}
.c_ff7e00 {
  color: #ff7e00;
}
.c_40a77a {
  color: #40a77a;
}
.f14 {
  font-size: 14px;
}
.f18 {
  font-size: 18px;
}
.media_640 {
  display: none;
}
.tb_btn {
  cursor: pointer;
  padding: 8px 18px;
  transition: all 0.3s;
  min-width: 102px;
  margin-left: 18px;
  &:first-child {
    margin-left: 0;
  }
  &.small {
    padding: 3px 12px;
    min-width: 82px;
    font-size: 14px;
    &.tb_btn1:hover {
      background-color: $color;
      border-color: $color;
      color: #fff;
    }
  }
  &:focus {
    outline: none;
  }
}
.tb_btn1 {
  @extend .tb_btn;
  background-color: $color;
  border: 1px solid $color;
  color: #fff;
  &:hover {
    background-color: darken($color, 5%);
    border-color: darken($color, 5%);
  }
}
.tb_btn2 {
  @extend .tb_btn;
  border: 1px solid $color;
  color: $color;
  &:hover {
    border-color: darken($color, 10%);
    color: darken($color, 10%);
  }
}
.tb_btn3 {
  @extend .tb_btn;
  border: 1px solid #d6d6d6;
  color: #666;
  &:hover {
    border-color: darken(#d6d6d6, 10%);
    color: darken(#666, 10%);
  }
}
.tb_btn4 {
  @extend .tb_btn;
  background-color: $c_ff4146;
  border: 1px solid $c_ff4146;
  color: #fff;
  &:hover {
    background-color: darken($c_ff4146, 5%);
    border-color: darken($c_ff4146, 5%);
  }
}
.v-application {
  ul {
    list-style: none;
    padding: 0;
  }
  p {
    margin-bottom: 0;
    line-height: 30px;
  }
}
.tb_dialog {
  background-color: #fafafa;
  font-size: 16px;
  .tb_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 65px;
    padding: 0 20px;
    background-color: $color;
    color: #fff;
  }
  .tb_body {
    background-color: #fff;
    margin: 20px;
    font-size: 14px;
    max-height: 50vh;
    overflow-x: hidden;
  }
  .tb_footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 20px;
    .tbfc {
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        margin: 0 5px;
      }
    }
  }
}
.tb_dialog1 {
  .tb_body {
    padding: 60px 50px;
    .template_buy_flex {
      display: flex;
      justify-content: space-between;
      .tb_pic {
        width: 191px;
        height: 127px;
        border: 1px solid #ededed;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      .tb_info {
        padding-left: 45px;
        h2 {
          font-weight: normal;
          font-size: 18px;
          line-height: 1;
          margin-bottom: 15px;
          color: #666;
        }
        .tb_money {
          font-size: 20px;
        }
        ul {
          padding-top: 15px;
          color: #adadad;
          line-height: 26px;
        }
      }
    }
    .template_buy_text {
      margin-top: 20px;
      color: #878787;
      line-height: 2;
    }
  }
}
.tb_dialog2 {
  .tb_body {
    padding: 25px 30px;
    .authorize_buy_flex {
      ul {
        display: flex;
        justify-content: center;
        li {
          width: 167px;
          height: 226px;
          background-color: #fafafa;
          border: 1px solid #fafafa;
          display: flex;
          flex-direction: column;
          padding: 15px;
          overflow: hidden;
          margin-left: 10px;
          margin-right: 10px;
          &:hover {
            border-color: #eee;
          }
          &.active {
            border-color: $color;
            dt {
              color: $color;
            }
            .wp_check {
              background-color: $color;
              .v-icon {
                color: #fff;
              }
            }
          }
          .wp_check {
            background-color: #ececec;
            text-align: center;
            margin-left: -15px;
            margin-right: -15px;
            margin-bottom: -15px;
            padding: 5px 0;
            .v-icon {
              color: #b3b3b3;
            }
          }
        }
      }
      dl {
        flex: 1;
        display: flex;
        flex-direction: column;
        line-height: 22px;
        align-items: center;
        padding: 15px 0;
        border-top: 1px solid #ededed;
        &:first-child {
          border-top: 0;
          padding-top: 0;
        }
        dt {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 15px;
        }
        dd {
          white-space: nowrap;
        }
        .small {
          font-size: 12px;
        }
      }
    }
    .authorize_buy_btn {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.tb_dialog3 {
  .tb_body {
    padding: 45px 60px;
    .flex_inline {
      display: flex;
      align-items: center;
      .label {
        flex: none;
      }
    }
    .label {
      margin-left: 15px;
      margin-right: 15px;
      &:first-child {
        margin-left: 0;
      }
    }
    ul {
      line-height: 36px;
    }
    .tb_money {
      font-size: 24px;
    }
    .partition {
      display: none;
    }
  }
}
.tb_dialog4 {
  background-color: #525252;
  color: #fff;
}
.tb_dialog5 {
  dl {
    line-height: 30px;
    padding: 25px 30px;
  }
  dt {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
  }
}
.tb_loading {
  animation: mdi-spin 2s infinite linear;
}

@keyframes mdi-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

@media screen and (max-width: 640px) {
  .media_640 {
    display: block;
  }
  .tb_dialog {
    height: 100%;
    display: flex;
    flex-direction: column;
    .tb_body {
      flex-grow: 1;
      max-height: none;
      margin: 0;
      padding: 30px;
    }
    .tb_footer {
      flex-wrap: wrap;
      padding-top: 30px;
      .next_btn {
        width: 100%;
        display: flex;
        flex-direction: row-reverse;
        padding-top: 20px;
      }
      > * {
        order: 1;
      }
      .tbfc {
        width: 100%;
        order: 0;
        padding-bottom: 30px;
      }
    }
  }
  .tb_dialog1 {
    .tb_body {
      .template_buy_flex {
        flex-direction: column;
        align-items: center;
        .tb_pic {
          margin-bottom: 30px;
        }
        .tb_info {
          padding-left: 0;
        }
      }
    }
  }
  .tb_dialog2 {
    .tb_body {
      .authorize_buy_flex {
        ul {
          flex-direction: column;
          li {
            width: 100%;
            height: auto;
            margin-bottom: 20px;
            dl:last-of-type {
              flex-direction: row;
              justify-content: center;
              margin-top: 10px;
              padding-top: 30px;
              dd {
                padding: 0 5px;
              }
            }
          }
        }
      }
    }
  }
  .tb_dialog3 {
    .tb_body {
      p {
        span {
          display: block;
        }
      }
      ul {
        li {
          flex-wrap: wrap;
          &:first-child {
            .label {
              width: 100%;
            }
          }
          .partition {
            display: block;
            + .label {
              margin-left: 0;
            }
          }
        }
      }
    }
    .tb_footer {
      .tb_btn2 {
        display: none;
      }
      .tbfc {
        flex-wrap: wrap;
        padding-bottom: 20px;
        .tb_btn2 {
          display: block;
        }
      }
      .media_640 {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 15px;
      }
    }
  }
  .tb_dialog4 {
    justify-content: center;
    .d-flex {
      width: 100%;
    }
    .v-progress-linear {
      width: 100% !important;
    }
  }
  .tb_dialog5 {
    .tb_footer {
      > * {
        width: 100%;
        display: flex;
        justify-content: space-between;
        &:first-child {
          display: none;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.tb_dialog3 {
  .tb_body {
    .v-input__slot {
      margin-bottom: 0 !important;
    }
    .v-text-field__details {
      display: none;
    }
  }
}
a {
  text-decoration: none;
}
.v-application {
  .v-application--wrap {
    min-height: 0;
  }
  .v-list--dense .v-list-item .v-list-item__subtitle,
  .v-list--dense .v-list-item .v-list-item__title,
  .v-list-item--dense .v-list-item__subtitle,
  .v-list-item--dense .v-list-item__title {
    line-height: 16px;
  }
  .v-toolbar__title {
    font-size: 20px;
  }
  .vuedl-layout {
    .v-card__actions {
      display: flex;
      justify-content: center;
      .spacer {
        display: none;
      }
    }
    .v-toolbar {
      height: 42px !important;
      background-color: #f8f8f8;
      border-bottom: 1px solid #eee;
    }
    .v-toolbar__content {
      height: 42px !important;
    }
    .v-toolbar__title {
      font-size: 14px;
      color: #333;
      font-weight: bold;
    }
    .v-card__text {
      font-size: 14px !important;
      color: #666;
      padding: 20px !important;
    }
    .v-btn {
      width: 120px;
      height: 40px;
      border-radius: 20px;
      &[action-key='true'] {
        background-color: $color;
        color: #fff;
        &:hover::before {
          opacity: 0.1;
        }
      }
      &[action-key='false'] {
        border: 1px solid #dedede;
      }
    }
    .vuedl-layout__closeBtn {
      top: 13px;
    }
  }
  .v-btn__content {
    font-size: 14px;
  }
  .v-btn {
    letter-spacing: normal;
    text-indent: 0;
  }
}
.templateBuy.loading {
  .v-dialog {
    box-shadow: none;
  }
  .tb_dialog {
    background-color: transparent;
  }
}
</style>
